
import { PROJECT_BRANDS } from '@/modules/brand/domain/brand';
import { QUIZ_PRODUCT_TYPES } from '@/modules/product/domain/product';

export default {
  name: 'BaseButton',
  props: {
    type: {
      type: String,
      default: 'nutrition-generic',
      validator: (val) => [...Object.values(QUIZ_PRODUCT_TYPES), 'flat'].includes(val),
    },
    withIcon: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: 'md',
      validator: (val) => ['xs', 'md'].includes(val),
    },
    brand: {
      type: String,
      default: PROJECT_BRANDS.reverse,
      validator: (val) => Object.values(PROJECT_BRANDS).includes(val),
    },
  },

  computed: {
    computedStyles() {
      const brandModifier =
        this.brand === PROJECT_BRANDS.muscleCharge ? 'base-button base-button--muscle-charge' : 'base-button';
      const typeModifier = `base-button--${this.type}`;
      const sizeModifier = `base-button--size-${this.size}`;

      return [brandModifier, typeModifier, sizeModifier];
    },
    showRightIcon() {
      return this.withIcon && !this.disabled;
    },
  },
};
